import { render, staticRenderFns } from "./RouteCard.vue?vue&type=template&id=3bdeffc4"
import script from "./RouteCard.vue?vue&type=script&lang=js"
export * from "./RouteCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports